import { IOrigensLead } from "../../../Interfaces/Vendas/OrigemLead/OrigemLeadInterface";
import AxiosVendas from "../../Config/ApiVendas";
import Service from "../../Service";

export async function VendasListarOrigensLeadService() {
    return Service(
        AxiosVendas.get<Array<IOrigensLead>>(
            `/app/origemlead/listarorigenslead`
        )
    );
}
